<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="">
        <b-col
          cols="12"
          md="8"
        >
          <label>Produto</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="dataForm.id_item"
            :options="items"
            class="w-auto"
            label="item_nome"
            :reduce="val => val.id"
            @search="onSearch"
            @input="(val) => onChangeItem(val)"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <label for="">Preço</label>
          <b-input-group
            size="md"
            prepend="R$"
          >
            <b-form-input
              v-model="dataForm.preco_venda"
              type="number"
              :number-of-decimals="2"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :placeholder="$store.state.appConfig.isRTL ? '0,00' : '0.00'"
              :step="0.01"
              :options="optionsMask.number"
            />

          </b-input-group>
        </b-col>

        <b-col
          md="12"
          class="text-right mt-2 d-flex align-items-center justify-content-end"
        >
          <b-button
            v-if="!editAtualizar"
            class="mr-1"
            variant="danger"
            @click="$emit('cancel')"
          >
            Limpar
          </b-button>
          <b-button
            variant="primary"
            @click="saveItem"
          >
            {{ editAtualizar ? 'Adicionar' : 'Atualizar' }}
          </b-button>

        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BFormInput, BCardBody, BRow, BCol, BButton,
  BInputGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useOptionsMask from '@/composables/useOptionsMask'
import { getUserData } from '@/auth/utils'

const { optionsMask } = useOptionsMask()

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BInputGroup,
    BFormInput,
    vSelect,
  },
  model: {
    prop: 'filters',
    event: 'updateFilters',
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    optionsItems: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      optionsMask,
    }
  },
  computed: {
    editAtualizar() {
      return this.value.id === null
    },
    dataForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    items: {
      get() {
        return this.optionsItems
      },
      set(value) {
        this.$emit('updateOptionsItems', value)
      },
    },
  },
  methods: {
    onChangeItem(val) {
      this.value.id_item = val
    },
    onSearch(search, loading) {
      if (search !== '') {
        loading(true)
        const userData = getUserData()
        const params = {
          q: search,
          perPage: 5,
          sortDesc: true,
          id_vendedor: this.idVendedor || (userData?.vendedor?.id || null),
        }

        this.$store.dispatch('appAdmProdutos/findAllbyVendedor', params)
          .then(res => {
            loading(false)
            this.$emit('updateOptionsItems', res.data.data)
          })
          .catch(() => {
            loading(false)
            // Adicione um tratamento de erro, se necessário
          })
      }
    },
    saveItem() {
      this.dataForm.id_tabela_preco = this.$route.params.id
      this.$emit('saveItem', this.dataForm)
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
